// Centralizes the tone-color derivation that screens previously duplicated via
// colors[`${tone}Soft`] / `${tone}Line` keyed lookups. A "tone" is any semantic
// color family that ships base / *Soft / *Line variants.

import type { ColorScheme } from './colors';

export type Tone =
  | 'accent'
  | 'info'
  | 'success'
  | 'warn'
  | 'danger'
  | 'purple'
  | 'teal'
  | 'neutral';

export interface ToneColors {
  /** Strong color — text/icon/foreground and solid fills. */
  fg: string;
  /** Soft tint — chip/badge background. */
  bg: string;
  /** Hairline — chip/badge border. */
  border: string;
}

/** Resolve a tone family to its { fg, bg, border } triple for the active theme. */
export function toneColors(colors: ColorScheme, tone: Tone): ToneColors {
  return {
    fg: colors[tone],
    bg: colors[`${tone}Soft` as keyof ColorScheme] as string,
    border: colors[`${tone}Line` as keyof ColorScheme] as string,
  };
}
